module.exports = __webpack_public_path__ + "img/product6p.90ad802d.png";